// extracted by mini-css-extract-plugin
module.exports =  {"unit":"var(--ring-unit)","icon":"CreateEntityButton-module__icon--SI","earlyAccessTag":"CreateEntityButton-module__earlyAccessTag--lr"};